export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #E6EAEE",
    outline: "none",
    // cursor: "none",
    height: "44px",
    position: "relative",
  }),
  //   menu: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: "lightgray",
  //     // Add any other custom styles you want for the menu here
  //   }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "var(--color-primary)" : "white",
    // Add any other custom styles you want for the options here
  }),
};
